export const customerDtoFields = [{
        name: "code",
        title: "Codice",
        render: (record) => record.customer.code
    }, {
        name: "name",
        title: "Nominativo",
        render: (record) => record.customer.name
    }, {
        name: "address",
        title: "Indirizzo",
        render: (record) => record.customer.address
    }, {
        name: "zipCode",
        title: "CAP",
        render: (record) => record.customer.zipCode
    }, {
        name: "city",
        title: "Comune",
        render: (record) => record.customer.city
    }, {
        name: "province",
        title: "Provincia",
        render: (record) => record.customer.province
    }, {
        name: "fiscalCode",
        title: "Codice Fiscale",
        render: (record) => record.customer.fiscalCode
    }, {
        name: "vatNumber",
        title: "Partita IVA",
        render: (record) => record.customer.vatNumber
    }, {
        name: "customerType",
        title: "Tipo cliente",
        render: (record) => record.customerTypeDescription
    }];
